// src/app/core/guards/auth-guard.ts
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '../services/auth';

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload.exp) return true; // if no exp present, assume valid (adjust if needed)
    const now = Math.floor(Date.now() / 1000);
    return payload.exp > now;
  } catch {
    return false;
  }
}

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  const token = typeof auth.getToken === 'function' ? auth.getToken() : null;
  const loggedIn = !!token && isTokenValid(token);

  const url = state.url ?? '';

  // treat these as public routes (when visited -> if logged in redirect to dashboard)
  const publicPrefixes = ['', '/login', '/register', '/forgot'];

  const isPublic = publicPrefixes.some(p => (p === '' ? url === '' : url.startsWith(p)));

  if (isPublic) {
    // If user is already authenticated, send them to dashboard
    return loggedIn ? router.parseUrl('/dashboard') : true;
  }

  // otherwise it's a protected route request: allow only if authenticated
  return loggedIn ? true : router.parseUrl('/login');
};
